import { create } from "zustand";
import { utcTimezones } from "../utils/constants";

type TimezoneKey = keyof typeof utcTimezones;

interface TimezoneState {
  timezone: TimezoneKey;
  localTime: string;
  utcTimezone: string;
  updateTimezone: (data: { timezone: TimezoneKey; localTime: string }) => void;
}

export const useTimezoneStore = create<TimezoneState>((set) => ({
  timezone: "UTC+0",
  localTime: "00:00",
  utcTimezone: utcTimezones["UTC+0"],

  updateTimezone: ({ timezone, localTime }) =>
    set(() => ({
      timezone,
      localTime,
      utcTimezone: utcTimezones[timezone],
    })),
})); 